/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CompanyDocumentDetailQueryResponse,
  CompanyDocumentQueryResponse,
  CompanyDocumentRelatedCompaniesQueryResponse,
  CreateCompanyDocumentCommandBody,
  CreateCompanyDocumentResponse,
  GetDocumentsParams,
  UpdateCompanyDocumentCommandBody,
  UpdateCompanyDocumentPermissionCommandBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocuments = (
    params: GetDocumentsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyDocumentQueryResponse>(
      {url: `/api/v1/company-document`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDocumentsQueryKey = (params: GetDocumentsParams,) => {
    return [`/api/v1/company-document`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocuments>>, GetDocumentsParams['page']>, TError = ErrorType<unknown>>(params: GetDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']> = ({ signal, pageParam }) => getDocuments({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocuments>>, GetDocumentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocuments>>, GetDocumentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocuments>>, GetDocumentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocuments>>, GetDocumentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData, Awaited<ReturnType<typeof getDocuments>>, QueryKey, GetDocumentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(params: GetDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>> = ({ signal }) => getDocuments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsQueryError = ErrorType<unknown>


export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(params: GetDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>> = ({ signal }) => getDocuments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentsSuspense<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentsSuspense<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentsSuspense<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentsSuspense<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<unknown>>(
 params: GetDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyDocumentRelatedCompanies = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyDocumentRelatedCompaniesQueryResponse>(
      {url: `/api/v1/company-document/${id}/related-companies`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyDocumentRelatedCompaniesQueryKey = (id: string,) => {
    return [`/api/v1/company-document/${id}/related-companies`] as const;
    }

    
export const getGetCompanyDocumentRelatedCompaniesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentRelatedCompaniesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>> = ({ signal }) => getCompanyDocumentRelatedCompanies(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentRelatedCompaniesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>
export type GetCompanyDocumentRelatedCompaniesInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyDocumentRelatedCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentRelatedCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentRelatedCompaniesInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDocumentRelatedCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentRelatedCompaniesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>> = ({ signal }) => getCompanyDocumentRelatedCompanies(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentRelatedCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>
export type GetCompanyDocumentRelatedCompaniesQueryError = ErrorType<unknown>


export function useGetCompanyDocumentRelatedCompanies<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompanies<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompanies<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentRelatedCompanies<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentRelatedCompaniesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDocumentRelatedCompaniesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentRelatedCompaniesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>> = ({ signal }) => getCompanyDocumentRelatedCompanies(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentRelatedCompaniesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>>
export type GetCompanyDocumentRelatedCompaniesSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyDocumentRelatedCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentRelatedCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentRelatedCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentRelatedCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentRelatedCompaniesSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyDocumentById = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyDocumentDetailQueryResponse>(
      {url: `/api/v1/company-document/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyDocumentByIdQueryKey = (id: string,) => {
    return [`/api/v1/company-document/${id}`] as const;
    }

    
export const getGetCompanyDocumentByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentById>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentById>>> = ({ signal }) => getCompanyDocumentById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentById>>>
export type GetCompanyDocumentByIdInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentById>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDocumentById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDocumentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentById>>> = ({ signal }) => getCompanyDocumentById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentById>>>
export type GetCompanyDocumentByIdQueryError = ErrorType<unknown>


export function useGetCompanyDocumentById<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentById<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentById<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentById<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDocumentByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDocumentByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDocumentById>>> = ({ signal }) => getCompanyDocumentById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDocumentByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDocumentById>>>
export type GetCompanyDocumentByIdSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyDocumentByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDocumentByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDocumentByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyDocumentById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDocumentById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDocumentByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateCompanyDocument = (
    id: string,
    updateCompanyDocumentCommandBody: BodyType<UpdateCompanyDocumentCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      const formData = new FormData();
if(updateCompanyDocumentCommandBody.buslineIds !== undefined) {
 updateCompanyDocumentCommandBody.buslineIds.forEach(value => formData.append('buslineIds', value.toString()));
 }
if(updateCompanyDocumentCommandBody.file !== undefined) {
 formData.append('file', updateCompanyDocumentCommandBody.file)
 }
if(updateCompanyDocumentCommandBody.name !== undefined) {
 formData.append('name', updateCompanyDocumentCommandBody.name)
 }
if(updateCompanyDocumentCommandBody.documentCategoryId !== undefined) {
 formData.append('documentCategoryId', updateCompanyDocumentCommandBody.documentCategoryId.toString())
 }

      return instance<CreateCompanyDocumentResponse>(
      {url: `/api/v1/company-document/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getUpdateCompanyDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocument>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocument>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentCommandBody>}, TContext> => {
    
const mutationKey = ['updateCompanyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyDocument>>, {id: string;data: BodyType<UpdateCompanyDocumentCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompanyDocument(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDocument>>>
    export type UpdateCompanyDocumentMutationBody = BodyType<UpdateCompanyDocumentCommandBody>
    export type UpdateCompanyDocumentMutationError = ErrorType<unknown>

    export const useUpdateCompanyDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocument>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyDocument>>,
        TError,
        {id: string;data: BodyType<UpdateCompanyDocumentCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteCompanyDocument = (
    id: string,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/company-document/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCompanyDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDocument>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCompanyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyDocument(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyDocument>>>
    
    export type DeleteCompanyDocumentMutationError = ErrorType<unknown>

    export const useDeleteCompanyDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyDocument>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCompanyDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const uploadCompanyDocument = (
    createCompanyDocumentCommandBody: BodyType<CreateCompanyDocumentCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(createCompanyDocumentCommandBody.buslineIds !== undefined) {
 createCompanyDocumentCommandBody.buslineIds.forEach(value => formData.append('buslineIds', value.toString()));
 }
if(createCompanyDocumentCommandBody.file !== undefined) {
 formData.append('file', createCompanyDocumentCommandBody.file)
 }
formData.append('name', createCompanyDocumentCommandBody.name)
formData.append('documentCategoryId', createCompanyDocumentCommandBody.documentCategoryId.toString())

      return instance<CreateCompanyDocumentResponse>(
      {url: `/api/v1/company-document/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getUploadCompanyDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCompanyDocument>>, TError,{data: BodyType<CreateCompanyDocumentCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadCompanyDocument>>, TError,{data: BodyType<CreateCompanyDocumentCommandBody>}, TContext> => {
    
const mutationKey = ['uploadCompanyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadCompanyDocument>>, {data: BodyType<CreateCompanyDocumentCommandBody>}> = (props) => {
          const {data} = props ?? {};

          return  uploadCompanyDocument(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadCompanyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadCompanyDocument>>>
    export type UploadCompanyDocumentMutationBody = BodyType<CreateCompanyDocumentCommandBody>
    export type UploadCompanyDocumentMutationError = ErrorType<unknown>

    export const useUploadCompanyDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCompanyDocument>>, TError,{data: BodyType<CreateCompanyDocumentCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadCompanyDocument>>,
        TError,
        {data: BodyType<CreateCompanyDocumentCommandBody>},
        TContext
      > => {

      const mutationOptions = getUploadCompanyDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateCompanyDocumentPermission = (
    id: string,
    updateCompanyDocumentPermissionCommandBody: BodyType<UpdateCompanyDocumentPermissionCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/company-document/${id}/permission`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDocumentPermissionCommandBody
    },
      options);
    }
  


export const getUpdateCompanyDocumentPermissionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocumentPermission>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentPermissionCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocumentPermission>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentPermissionCommandBody>}, TContext> => {
    
const mutationKey = ['updateCompanyDocumentPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyDocumentPermission>>, {id: string;data: BodyType<UpdateCompanyDocumentPermissionCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompanyDocumentPermission(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyDocumentPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDocumentPermission>>>
    export type UpdateCompanyDocumentPermissionMutationBody = BodyType<UpdateCompanyDocumentPermissionCommandBody>
    export type UpdateCompanyDocumentPermissionMutationError = ErrorType<unknown>

    export const useUpdateCompanyDocumentPermission = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDocumentPermission>>, TError,{id: string;data: BodyType<UpdateCompanyDocumentPermissionCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyDocumentPermission>>,
        TError,
        {id: string;data: BodyType<UpdateCompanyDocumentPermissionCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyDocumentPermissionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    